<template>
	<div>
		<game-detail :details='details'></game-detail>
	</div>
</template>

<script>
	import gameDetail from '../../components/gamedetail/gamedetail'

	export default {
		data() {
			var province = this.$route.params.province;
//			console.log(province)
			return {
				details: {
					logo_img: require(`../../images/xianlaigame/xl_${province}.png`),
					name: '',
					size: '',
					load_count: '',
					desp: '',
					ios_url: '',
					android_url: '',
					ercodeimg: require(`../../images/gamecenter_ercode/ercode_${province}.png`),
					list_img1: require(`../../images/download/down_${province}1.png`),
					list_img2: require(`../../images/download/down_${province}2.png`),
					list_img3: require(`../../images/download/down_${province}3.png`),
					cut_img1: require(`../../images/download/cut_${province}1.png`),
					cut_img2: require(`../../images/download/cut_${province}2.png`),
					cut_img3: require(`../../images/download/cut_${province}3.png`)
				},
				data:{
					
				}
			}

		},
		components: {
			gameDetail
		},
		mounted(){
			var province=this.$route.params.province;
			this.details.name=this.data[province].name;
			this.details.size=this.data[province].size;
			this.details.desp=this.data[province].desp;
			this.details.load_count=this.data[province].load_count;
			this.details.ios_url=this.data[province].ios_url;
			this.details.android_url=this.data[province].android_url;
		}
	}
</script>

<style scoped>

</style>
